<!-- 客户运输行为分析 -->
<template>
  <div>
    <el-card>
      <div class="title">
        <div>
          <p>山西能源集团有限公司</p>
          <p>客户ID: CM2023056789</p>
        </div>
        <div class="tag">
          <matrix-tag color="#166534" text="高价值客户"></matrix-tag>
          <matrix-tag color="#1E40AF" text="VIP客户"></matrix-tag>
        </div>
      </div>
      <matrix-statistics span="6" :list="statisticsList" background="#F9FAFB"></matrix-statistics>
      <div class="progress">
        <div class="progress-title">
          <p>月度计划完成进度</p>
          <p>78%</p>
        </div>
        <el-progress :percentage="78" color="#2563EB" :show-text="false" :stroke-width="10"></el-progress>
        <div class="progress-info">
          <p>计划: 15,000吨</p>
          <p>已完成: 11,700吨</p>
        </div>
      </div>
    </el-card>
    <el-card style="margin-top: 20px;">
      <div class="title">
        <p>运输行为分析</p>
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="echarts-box">
            <div class="echarts-title">
              <p>月度发运频次</p>
              <div>
                <el-button>柱状图</el-button>
                <el-button>折线图</el-button>
              </div>
            </div>
            <div id="bar"></div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="echarts-box">
            <div class="echarts-title">
              <p>年度运输趋势</p>
            </div>
            <div id="trend"></div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="echarts-box">
            <div class="echarts-title">
              <p>物资偏好分析</p>
            </div>
            <div id="analyse"></div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="echarts-box">
            <div class="echarts-title">
              <p>季节特征分析</p>
            </div>
            <div id="barTwo"></div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="title" style="margin-bottom: 10px;">
        <p>发货需求预测</p>
        <el-button type="primary" icon="el-icon-refresh-left">更新预测</el-button>
      </div>
      <matrix-statistics span="8" :list="list" background="#F9FAFB"></matrix-statistics>
      <div id="forecast"></div>
    </el-card>
    <div style="height: 80px;"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import matrixTag from '@/components/matrix/matrix-tag'
import matrixStatistics from '@/components/matrix/matrix-statistics'

export default {
  name: "store-management/index/index",
  components: {
    matrixTag,
    matrixStatistics
  },
  data() {
    return {
      statisticsList: [{
        label: '信用额度',
        value: 1200000,
        subhead: '剩余 ¥856,000',
        unit: '元',
        compareColor: '#16A34A'
      }, {
        label: '预付款金额',
        value: 4500000,
        subhead: '-¥12,000',
        unit: '元',
        compareColor: '#DC2626'
      }, {
        label: '月发运频次',
        value: 42156,
        unit: '次/月'
      }, {
        label: '常用物资',
        value: 153742,
        unit: '种'
      }, {
        label: '当月库存量',
        value: 12560,
        unit: '吨',
      }, {
        label: '铁运入库量',
        value: 8750,
        unit: '吨',
      }, {
        label: '汽运入库量',
        value: 3810,
        unit: '吨'
      }, {
        label: '汽运出库量',
        value: 15742,
        unit: '吨'
      }],
      list: [{
        label: '下周预测',
        value: 8500,
        unit: '吨',
        tip: '较上周增长',
        subhead: '12%',
        compareColor: '#16A34A',
        tag: '高需求',
        tagColor: '#1E40AF'
      }, {
         label: '下月预测',
        value: 32000,
        unit: '吨',
        tip: '较上月增长',
        subhead: '6%',
        compareColor: '#16A34A',
        tag: '中需求',
        tagColor: '#166534'
      }, {
        label: '下季度预测',
        value: 85000,
        unit: '吨',
        tip: '较上季度下降',
        subhead: '-8%',
        compareColor: '#DC2626',
        tag: '季节性波动',
        tagColor: '#854D0E'
      }],
    };
  },
  mounted() {
    this.barInit()
    this.trendInit()
    this.analyseInit()
    this.barTwoInit()
    this.forecastInit()
  },
  methods: {
    barInit() {
      let chartDom = document.getElementById('bar');
      let myChart = echarts.init(chartDom);
      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130],
            color: '#2563EB',
            type: 'bar'
          }
        ]
      };
      option && myChart.setOption(option);
    },
    trendInit() {
      let chartDom = document.getElementById('trend');
      let myChart = echarts.init(chartDom);
      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['2019', '2020', '2021', '2022', '2023', '2024'],
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          }
        },
        series: [
          {
            data: [820, 932, 1101, 1234, 1290, 1330],
            type: 'line',
            smooth: true,
            lineStyle: {
              color: '#10b981',
              width: 2,
            },
            itemStyle: {
              color: '#10b981',
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0.2,
                  color: 'rgba(16,185,129,0)'
                },
                {
                  offset: 1,
                  color: 'rgba(16,185,129,0.3)'
                }
              ])
            },

          }
        ]
      };
      option && myChart.setOption(option);
    },
    analyseInit() {
      let chartDom = document.getElementById('analyse');
      let myChart = echarts.init(chartDom);
      let data = [
        { value: 1048, name: '动力煤 Q5500' },
        { value: 735, name: '焦煤' },
        { value: 580, name: '无烟煤' },
        { value: 420, name: '褐煤' },
        { value: 220, name: '其他' },
      ]
      let total = 0
      data.forEach(res => {
        total = res.value + total
      });

      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        title: {
          text: '常用物资TOP5',
          textStyle: {
            color: '#374151',
            fontWeight: 'bold',
            fontSize: 14
          },
          right: 170,
          top: 80,
        },
        legend: {
          orient: 'vertial',
          right: 85,
          top: 115,
          textStyle: {
            color: '#374151',
            fontSize: 14,
            rich: {
              d: {
                width: "140%",
              },
              a: {
                width: 140,
              },
              b: {
                width: 40,
              },
              c: {
                width: 70,
              },
            },
          },
          formatter: params => {
            const item = data.find(res => res.name == params);
            let arr = [
              "{a|" + params + "}",
              "{c|" + `${(item.value / total).toFixed(0)}%` + "}" + "\n{d|}",
            ];

            return arr.join("");
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['65%', '90%'],
            right: 300,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#fff',
              borderWidth: 2
            },
            labelLine: {
              show: false
            },
            label: {
              show: false
            },
            data: data
          }
        ]
      };
      option && myChart.setOption(option);
    },
    barTwoInit() {
      let chartDom = document.getElementById('barTwo');
      let myChart = echarts.init(chartDom);
      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['一季度', '二季度', '三季度', '四季度']
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        series: [
          {
            data: [{
              value: 12360,
              itemStyle: {
                color: '#f59e0b'
              }
            }, {
              value: 20410,
              itemStyle: {
                color: '#10b981'
              }
            }, {
              value: 51450,
              itemStyle: {
                color: '#10b981'
              }
            }, {
              value: 18160,
              itemStyle: {
                color: '#f59e0b'
              }
            }],
            type: 'bar'
          }
        ]
      };
      option && myChart.setOption(option);
    },
    forecastInit() {
      let chartDom = document.getElementById('forecast');
      let myChart = echarts.init(chartDom);
      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          textStyle: {
            color: '#374151',
            fontSize: 14,
          },
          lineStyle: {
            type: 'solid'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          }
        },
        series: [
          {
            name: '实际运输量',
            data: [820, 932, 1101, 1234, 1290, 1330, 1320, 1101, 1234, 1290, 1330, 1320],
            type: 'line',
            lineStyle: {
              color: '#2563EB',
              width: 2,
            },
            itemStyle: {
              color: '#2563EB',
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0.2,
                  color: 'rgba(37,99,235,0)'
                },
                {
                  offset: 1,
                  color: 'rgba(37,99,235,0.3)'
                }
              ])
            },
          },
          {
            name: '预测运输量',
            data: ['-', '-', '-', '-', '-', '-', '-', '-', '-', 1590, 1730, 2020],
            type: 'line',
            lineStyle: {
              color: '#10b981',
              width: 2,
              type: 'dashed',
            },
            itemStyle: {
              color: '#10b981',
            },
          }
        ]
      };
      option && myChart.setOption(option);
    }
  }
};
</script>
<style scoped lang="scss">
#bar,
#trend,
#analyse,
#barTwo,
#forecast {
  width: 100%;
  height: 400px;
}

p {
  margin: 0;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    font-size: 18px;
    font-weight: 600;
    color: #1F2937;

    &:nth-child(2) {
      font-size: 14px;
      font-weight: normal;
      color: #6B7280;
      margin-top: 4px;
    }
  }

  .tag {
    display: flex;
    align-items: center;
  }
}

.progress {
  .progress-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;

    p {
      font-size: 14px;
      font-weight: 500;

      &:nth-child(1) {
        color: #374151;
      }

      &:nth-child(2) {
        color: #2563EB;
      }
    }
  }

  .progress-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 14px;

    p {
      font-size: 12px;
      color: #6B7280;
    }

  }
}

.echarts-box {
  background: #F9FAFB;
  border-radius: 12px;
  padding: 16px;
  margin-top: 20px;
  height: 465px;

  .echarts-title {
    font-size: 16px;
    font-weight: 500;
    color: #1F2937;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>